import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import { Sprite} from "pixi.js";
import {TweenLite} from "gsap";
import {FadePlate} from "@nolimitcity/slot-game/bin/timelinegameround/components/FadePlate";
export class ImmortalFruitsNearWinView extends BaseView {
    private _animatingItem: TimelineSprite;
    private _animatingItem2: TimelineSprite;
    private _fullScreenFade: FadePlate;
    private bottomGlow: Sprite;
    private isPortrait:boolean =false;

    private _anticipationAnimStarted: boolean = false;

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        const reelAttention: ScalableLayer = StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.REEL_ATTENTION.name);
        this._animatingItem = new TimelineSprite(GameResources.getTextures("anticipation"));
        this._animatingItem2 = new TimelineSprite(GameResources.getTextures("anticipation"));
        this.bottomGlow = new Sprite(GameResources.getTextures("bottomGlow")[0]);
        this._animatingItem.hide();
        this._animatingItem2.hide();
        this.bottomGlow.alpha =0;
        this.bottomGlow.blendMode =PIXI.BLEND_MODES.ADD;
        this._animatingItem.blendMode =PIXI.BLEND_MODES.ADD;
        this._animatingItem.anchor.set(0.5, 0);
        this._animatingItem2.anchor.set(0.5, 0);
        this.bottomGlow.anchor.set(0, 0);
        this.bottomGlow.x =  -ImmortalFruitsGameConfig.instance.SYMBOL_WIDTH;
        this._animatingItem.scale.set(1.86, 2);
        this._animatingItem2.scale.set(1.86, 2);
         //this._animatingItem.y = -ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT;
        this._fullScreenFade =new FadePlate(0x000000, 0.6);
        this._fullScreenFade.alpha=0;
        reelAttention.addChild(this._fullScreenFade);
        reelAttention.addChild(this.bottomGlow);
        reelAttention.addChild(this._animatingItem);
        reelAttention.addChild(this._animatingItem2)
    }

    /**
     * @inheritDoc
     */
    protected addEventListeners(): void {
        super.addEventListeners && super.addEventListeners();

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, () => this._anticipationAnimStarted = false);
    }

    /**
     * @description To play the animation.
     * @param reelId
     */
    public playAnimation(reelId: number): void {
        const pos: number[] = Helper.getSymbolPositions(reelId, 0);
        this.stopAllAnimations();
        this._anticipationAnimStarted = true;
        this._animatingItem.position.set(pos[0], pos[1]-90);
        this._animatingItem2.position.set(pos[0], pos[1]-90);

        this._animatingItem.show();
        this._animatingItem2.show();
        this._animatingItem.playLoop();
        this._animatingItem2.playLoop();
        if(this.isPortrait){
            this._animatingItem.y =23;
            this._animatingItem2.y =23;
        }else{
            this._animatingItem.position.set(pos[0], pos[1]-90);
            this._animatingItem2.position.set(pos[0], pos[1]-90);
        }
    }
    public fadeInAnimation(){
        this.bottomGlow.anchor.set(0,0.5);
        this.bottomGlow.position.set(Helper.getSymbolPositions(0,2)[0]-ImmortalFruitsGameConfig.instance.SYMBOL_WIDTH,  Helper.getSymbolPositions(0,3)[1]);

        if(this.isPortrait){

            this.bottomGlow.y = Helper.getSymbolPositions(0,3)[1]-70;
        }else{
            this.bottomGlow.y = Helper.getSymbolPositions(0,3)[1];
        }
        TweenLite.to(this.bottomGlow,0.1,{alpha:1});
        TweenLite.to(this._fullScreenFade,0.1,{alpha:0.6});
    }
    public fadeOutAnimation(){
        TweenLite.to(this.bottomGlow,0.1,{alpha:0});
        TweenLite.to(this._fullScreenFade,0.1,{alpha:0});
    }

    /**
     * @description To stop all the animations.
     */
    public stopAllAnimations(): void {

        this._animatingItem.hide();
        this._animatingItem2.hide();
        this._animatingItem2.stopLoop();
        this._animatingItem.stopLoop();
    }
     protected onResize(resizeData: IResizeData): void {

       if(resizeData.orientation==="portrait"){
           this.isPortrait =true;
           this._animatingItem.y =23;
           this._animatingItem2.y =23;
           this.bottomGlow.y = Helper.getSymbolPositions(0,3)[1]-70;
           this._fullScreenFade.resize(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X -3, ImmortalFruitsGameConfig.instance.PORTRAIT_OFFSET-8, ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH * 0.91+2, ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT + 8);
       }else{
           this.bottomGlow.y = Helper.getSymbolPositions(0,3)[1];
           this._fullScreenFade.resize(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X -2 , ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y -2, ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH*0.91+2  , ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT+4 );
           this._animatingItem.y = Helper.getSymbolPositions(0,0)[1]-90;
           this._animatingItem2.y=Helper.getSymbolPositions(0,0)[1]-90;
           this.isPortrait =false;
       }
    }

}